import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  updateDoc,
  increment,
} from "firebase/firestore";
import { db } from "./firebase"; // Importera din Firestore-konfiguration
import { getTenantIdFromHost } from "./Tenant/getTenantId";

export const saveResponse = async (responseData) => {
  const tenantId = getTenantIdFromHost();

  // 1) spara svaret
  const payload = {
    ...responseData,
    timestamp: serverTimestamp(),
  };

  const resRef = await addDoc(
    collection(db, "tenants", tenantId, "responses"),
    payload,
  );

  // // 2) bumpa räknaren på formuläret (atomic)
  // if (responseData?.surveyId) {
  //   await updateDoc(doc(db, "tenants", tenantId, "forms", responseData.surveyId), {
  //     responsesCount: increment(1),
  //     hasResponses: true, // valfritt men praktiskt
  //   });
  // }

  return resRef.id; // så du kan await:a och ev logga
};
